<template>
	<div class="cluster" id="cluster" v-if="authStatus && authStatus.isAuthenticated">
		<!-- <div class="row"><button class="hover" v-on:click="test()" id='demo'>Test</button></div> -->

		<!-- Cluster Controls -->
		<div class="cluster-controls">
			<button class="query-button"
				v-on:click="addCollection({
					parentCollection:{},
					ClientInstance:{},
					query:{}
				})"
				v-bind:class="{hover: !activeChild}"
				:disabled="activeChild"
				>+</button>
			<span class = "spacer"></span>
			<button	class="query-button"
				v-on:click="queryButtonMode = queryButtonMode!==3?3:0"
				v-bind:class="{
					selected: queryButtonMode == 3,
					hover: !activeChild && pinnedQueries
				}"
				:disabled="activeChild || !pinnedQueries"
				>
				<img class="button-image" :src="require('../assets/UnPin.png')"/>
			</button>
			<QueryButton class="query-component"
				v-for="(q) in pinnedQueries"
				v-on:querySelect="clusterQueryHandler($event)"
				v-bind:key="q.ID"
				v-bind:queries="q"
				v-bind:enableDropDown="true"
				v-bind:queryMode="queryButtonMode"
				v-bind:disable="activeChild"
			/>
		</div>

		<!-- Images -->
		<div class="images">
			<button class="images hover" v-on:click="images(Cluster)" id='images'>Images</button>
			<ImagesView
				v-if="Cluster.showImages"
				v-bind:auth-status="authStatus"
			/>
		</div>


		<!-- Collections -->
		<div class="collections-container"
			id="collections"
			>
			<CollectionView
				v-for="(c) in this.activeCollections"
				v-bind:key="c.ID"
				v-bind:activeChild="activeChild"

				v-bind:Collection="c"
				v-bind:activeRequest="activeRequest"
				v-bind:windowWidth="windowWidth"
				v-bind:queries="allQueries[c.Root?.ID || '']"
				v-bind:pauseICollections="pauseICollections"
				v-bind:authStatus="authStatus"

				v-on:activateChild="activeChild = $event"
				v-on:addBranch="addBranch($event)"
				v-on:removeBranch="removeBranch($event)"
				v-on:addClientBranch="addClientBranch($event)"
				v-on:addTempClientBranch="addTempClientBranch($event)"

				v-on:callInstanceMutation="callInstanceMutation($event)"
				v-on:callModalCollection="callModalCollection($event)"
				v-on:callTool="callTool($event)"
				v-on:clearClientInstances="clearClientInstances($event)"
				v-on:clickToFilter="clickToFilter($event)"
				v-on:clientInstanceIsActive="clientInstanceIsActive($event)"
				v-on:clientInstanceRequest="clientInstanceRequest($event)"
				v-on:clientInstanceResponse="clientInstanceResponse($event)"
				v-on:configBranch="configBranch($event)"
				v-on:createITrees="createITrees($event)"

				v-on:deleteClientBranch="deleteClientBranch($event)"
				v-on:deleteNod="deleteNod($event)"
				v-on:clientInstanceDisplay="clientInstanceDisplay($event)"

				v-on:emptyTree="emptyTree($event)"
				v-on:editBuffer="editBuffer($event)"
				v-on:editBBuffer="editBBuffer($event)"

				v-on:fixTrees="fixTrees()"
				
				v-on:hideBranch="hideBranch($event)"

				v-on:setRoot="setRoot($event)"

				v-on:loadQuery="loadQuery($event)"

				v-on:pageCounter="pageCounter($event)"
				v-on:purgeCollection="purgeCollection($event)"

				v-on:queryBtnClick="queryBtnClick($event)"
				v-on:addQuery="addQuery($event)"
				v-on:deleteQuery="deleteQuery($event)"
				v-on:queryHandler="queryHandler($event)"

				v-on:refreshITrees="refreshITrees()"
				v-on:refreshTrees="refreshTrees($event)"
				v-on:removeCollection="removeCollection($event)"
				v-on:createTree="createTree($event)"
				v-on:moveBranch="moveBranch($event)"
				v-on:setActiveQuery="setActiveQuery($event)"
				v-on:setActiveRequest="setActiveRequest($event)"
				v-on:setITreeIsStale="setITreeIsStale($event)"
				v-on:setPauseICollections="setPauseICollections($event)"
				v-on:setQueryIsStale="setQueryIsStale($event)"
				v-on:setRootInstanceID="setRootInstanceID($event)"
				v-on:setTreeIsStale="setTreeIsStale($event)"
				v-on:setUseFilters="setUseFilters($event)"

				v-on:toggleClickToFilter="toggleClickToFilter($event)"
				v-on:toggleSelections="toggleSelections($event)"
				v-on:trigger="trigger($event)"
				v-on:updateBranch="updateBranch($event)"
				v-on:updateBranchAlias="updateBranchAlias($event)"

				v-on:updateCBFilter="updateCBFilter($event)"
				v-on:updateTrees="updateTrees($event)"
			/>

			<SelectInstance
				v-for="(mC) in this.modalCollections"
				v-bind:key="mC.ID"
				v-bind:modalCollection="mC"
				v-bind:activeChild="activeChild"
				v-bind:activeRequest="activeRequest"
				v-bind:authStatus="authStatus"
				v-bind:pauseICollections="pauseICollections"
				v-bind:windowWidth="windowWidth"
				v-bind:parentInstance="{}"
				v-bind:modalVars="modalVars"
				v-bind:queries="allQueries[mC.Root.ID]"

				v-on:activateChild="activeChild = $event"
				v-on:addClientBranch="addClientBranch($event)"

				v-on:callInstanceMutation="callInstanceMutation($event)"
				v-on:callModalCollection="callModalCollection($event)"
				v-on:callTool="callTool($event)"
				v-on:clearClientInstances="clearClientInstances($event)"
				v-on:clientInstanceIsActive="clientInstanceIsActive($event)"
				v-on:clientInstanceRequest="clientInstanceRequest($event)"
				v-on:clientInstanceResponse="clientInstanceResponse($event)"
				v-on:configBranch="configBranch($event)"
				v-on:createITrees="createITrees($event)"

				v-on:deleteClientBranch="deleteClientBranch($event)"
				v-on:deleteNod="deleteNod($event)"
				v-on:clientInstanceDisplay="clientInstanceDisplay($event)"

				v-on:emptyTree="emptyTree($event)"
				v-on:editBuffer="editBuffer($event)"
				v-on:editBBuffer="editBBuffer($event)"

				v-on:fixTrees="fixTrees()"

				v-on:setRoot="setRoot($event)"

				v-on:loadQuery="loadQuery($event)"

				v-on:pageCounter="pageCounter($event)"
				v-on:purgeCollection="purgeCollection($event)"

				v-on:queryBtnClick="queryBtnClick($event)"
				v-on:addQuery="addQuery($event)"
				v-on:deleteQuery="deleteQuery($event)"
				v-on:queryHandler="queryHandler($event)"

				v-on:refreshITrees="refreshITrees()"
				v-on:refreshTrees="refreshTrees($event)"
				v-on:removeCollection="removeCollection($event)"
				v-on:createTree="createTree($event)"

				v-on:setActiveQuery="setActiveQuery($event)"
				v-on:setActiveRequest="setActiveRequest($event)"
				v-on:setITreeIsStale="setITreeIsStale($event)"
				v-on:setPauseICollections="setPauseICollections($event)"
				v-on:setQueryIsStale="setQueryIsStale($event)"
				v-on:setRootInstanceID="setRootInstanceID($event)"
				v-on:setTreeIsStale="setTreeIsStale($event)"
				v-on:setUseFilters="setUseFilters($event)"
				v-on:toggleSelections="toggleSelections($event)"


				v-on:trigger="trigger($event)"

				v-on:updateCBFilter="updateCBFilter($event)"
				v-on:updateTrees="updateTrees($event)"
			/>
		</div>
		
	</div>
</template>

<script>
	import _ from 'lodash'
import {cache, client} from '../main.js'
	import {v4 as uuidv4} from  'uuid'
	import ImagesView from './ImagesView.vue'
	import GetClientAuthStatusQuery from '../graphql/user/GetClientAuthStatusQuery.gql'
	import AddBranchMutation from '../graphql/server/Branch/AddBranchMutation.gql'
	import addCluster from '../graphql/client/Cluster/AddCluster.gql'
	import AddIBranchAndParentMutation from '../graphql/server/iBranch/AddIBranchAndParentMutation.gql'
	import AddIBranchMutation from '../graphql/server/iBranch/AddIBranchMutation.gql'
	import AddNewIBranchAndParentMutation from '../graphql/server/iBranch/AddNewIBranchAndParentMutation.gql'
	import AddNewIBranchMutation from '../graphql/server/iBranch/AddNewIBranchMutation.gql'
	import AddQueryMutation from '../graphql/server/ICollection/AddQueryMutation.gql'
	import BranchItemFragment from '../graphql/server/Branch/BranchItemFragment.gql'
	import clientInstanceRequest from '../graphql/client/ClientInstance/clientInstanceRequestFragment.gql'
	import CollectionView from './CollectionView.vue'
	import DeleteCollectionInstanceMutation from '../graphql/server/Instance/DeleteCollectionInstanceMutation.gql'
	import DeleteInstanceMutation from '../graphql/server/Instance/DeleteInstanceMutation.gql'
	import DeleteNod from '../graphql/server/Nod/DeleteNod.gql'
	import DeleteQueryMutation from '../graphql/server/ICollection/DeleteQueryMutation.gql'
	import editBBuffer from '../graphql/client/ClientBranch/editBBufferFragment.gql'
	import editBuffer from '../graphql/client/ClientInstance/editBufferFragment.gql'
	import editMode from '../graphql/client/Collection/editModeFragment.gql'
	import enableEdit from '../graphql/client/Collection/enableEditFragment.gql'
	import getBranch from '../graphql/server/Branch/Branch.gql'
	import getCluster from '../graphql/client/Cluster/Cluster.gql'
	import getQueries from '../graphql/server/ICollection/Queries.gql'

	import HideBranchMutation from '../graphql/server/Branch/HideBranchMutation.gql'

	import isActive from '../graphql/client/ClientInstance/isActiveFragment.gql'
	import isPinned from '../graphql/server/Instance/isPinnedFragment.gql'
	import iTreeIsStale from '../graphql/client/ITrees/iTreeIsStaleFragment.gql'
	import MoveBranch from '../graphql/server/Branch/MoveBranchMutation.gql'
	import PinQueryMutation from '../graphql/server/ICollection/PinQueryMutation.gql'
	import QueryButton from './QueryButton.vue'
	import RemoveBranch from '../graphql/server/Branch/RemoveBranchMutation.gql'
	import RemoveIBranchMutation from '../graphql/server/Instance/RemoveIBranchMutation.gql'
	import rootInstanceID from '../graphql/client/Collection/UpdateRootInstanceIDFragment.gql'

	import ShowImagesFragment from '../graphql/client/Cluster/ShowImagesFragment.gql'

	import SelectInstance from './SelectInstance.vue'
	import setFilter from '../graphql/client/ClientBranch/setFilterFragment.gql'
	import toolVis from '../graphql/client/ClientBranch/toolVisFragment.gql'
	import treeIsStale from '../graphql/client/Tree/TreeIsStaleFragment.gql'
	import UpdateBranchAlias from '../graphql/server/Branch/UpdateBranchAliasMutation.gql'
	import UpdateBranchFragment from '../graphql/client/Tree/UpdateBranchFragment.gql'
	import UpdateCollectionsFragment from '../graphql/client/Cluster/UpdateCollectionsFragment.gql'
	import UpdateInstanceFragment from '../graphql/client/ITree/UpdateInstanceFragment.gql'
	import UpdateInstanceMutation from '../graphql/server/Instance/UpdateInstanceMutation.gql'
	import UpdateITreesFragment from '../graphql/client/ITrees/UpdateITreesFragment.gql'
	// import UpdateModalVarsFragment from '../graphql/client/Collection/UpdateModalVarsFragment.gql'
	import UpdateNod from '../graphql/server/Nod/UpdateNod.gql'
	import UpdatePagesFragment from '../graphql/client/Collection/UpdatePagesFragment.gql'
	import getGroups from '../graphql/server/Groups/Groups.gql'
	import CreateGroupMutation from '../graphql/server/Groups/CreateGroupMutation.gql'

	export default {
		name: 'ClusterView',
		components: {
			CollectionView,
			ImagesView,
			QueryButton,
			SelectInstance,
		},
		data() {
			return {
				activeChild: false, // global - disables all content except Tree or Instance child while editing
				activeRequest: false,
				authStatus: { isAuthenticated: false, userID: null, isAdmin: false },
				Cluster: {},
				modalVars: {},
				mutationBuffer: {},
				pauseICollections: false,
				Queries: [],
				queryButtonMode: 0,
				windowWidth: window.innerWidth,
				// Groups data
				userGroups: [],
				selectedGroupID: null,
				showGroupCreation: false,
				newGroupName: 'My '
			}
		},
		apollo: {
			authStatus: {
				query: GetClientAuthStatusQuery,
				fetchPolicy: 'cache-only', // Force it to look ONLY at the local cache
				// This ensures that even if the cache is being updated,
				// the component stays reactive to the changes
				watchLoading(isLoading) {
					console.log('Cluster Auth Loading:', isLoading);
				}
			},
			Cluster:{query: getCluster},
			Queries:{
				query:getQueries,
				variables(){
					return {userID: this.authStatus.userID}
				},
				skip() {return !this.authStatus?.userID}
			},
			userGroups: {
				query: getGroups,
				variables() {
					return {userID: this.authStatus.userID}
				},
				skip() {return !this.authStatus?.userID},
				update(data) {
					return data.Groups || [];
				}
			}
		},
		methods: {
			modifyClientBranch({ Branches, Branch, Parent, ClientBranches }) {
				const parentPath = Parent?.path || ''
				const parentID = Parent?.ID || ''
				// Read fresh Branch.item from cache (mirroring createClientBranch pattern)
				let branchItem = Number(Branch.item)
				const branchCacheId = cache.identify({ __typename: 'Branch', ID: Branch.ID })
				if (branchCacheId) {
					const data = cache.readFragment({ id: branchCacheId, fragment: BranchItemFragment })
					if (data?.item !== undefined) {
						branchItem = Number(data.item)
					}
				}
				const itemString = ("00" + branchItem).slice(-3)
				const path = parentPath === '' ? '001' : `${parentPath}.${itemString}`
				const candidates = ClientBranches.filter(cB => cB.Branch.ID === Branch.ID)
				const clientBranch = candidates.find(cB => {
					const cbParentID = cB.parentCB?.ID || ''
					const cbParentPath = cB.parentCB?.path || ''
					// Prioritize parentID matching when available (fixes duplicates under different parents)
					return parentID ? (cbParentID === parentID) : (cbParentPath === parentPath)
				}) || candidates[0]
				if (!clientBranch) {
					console.warn('[modifyClientBranch] no clientBranch', { branchID: Branch.ID, parentPath, parentID })
					return
				}
				
				client.cache.modify({
					id: cache.identify({ __typename: 'ClientBranch', ID: clientBranch.ID }),
					fields: {
						parentCB(existing = {}) { return { ...(existing || {}), path: parentPath } },
						path() { return path }
					}
				})

				// Recurse using actual client-children so duplicates remain distinct per parent
				const childClientBranches = ClientBranches.filter(cb => cb.parentCB?.ID === clientBranch.ID)
				childClientBranches.forEach(childCB => {
					const childBranch = Branches.find(b => b.ID === childCB.Branch.ID) || childCB.Branch
					this.modifyClientBranch({
						Branches,
						Branch: childBranch,
						Parent: {
							ID: clientBranch.ID,
							path,
							isCollection: clientBranch.Branch.Child?.isCollection || false
						},
						ClientBranches
					})
				})
			},
			moveBranch(vars) {
				// console.log('moveBranch ', vars)
				const {Collection, ClientBranch, direction} = vars
				const fromPath = ClientBranch.path
				const fromIndex = ClientBranch.Branch.item
				const parentPath = fromPath.substring(0, fromPath.length-4)
				const toIndex = direction === "+" ? 
					String(parseInt(fromIndex) + 1) : 
					String(parseInt(fromIndex) - 1)
				const toPath = parentPath + "." + ("00" + toIndex).slice(-3)

				// Find target branch
				const parentID = ClientBranch.Branch.Parent.ID
				const targetBranch = Collection.Tree.ClientBranches.find(b => b.path === toPath)
				if (!targetBranch) {
					return
				}
				const fromID = ClientBranch.Branch.Child.ID
				const fromItem = fromIndex
				const toID = targetBranch.Branch.Child.ID
				const toItem = toIndex

				this.$apollo.mutate({
					mutation: MoveBranch,
					variables: { parentID, fromID, fromItem, toID, toItem },
					// update: (cache) => {
					update: () => {
						// seems this might not be necessary, the Branch.item updates automatically for some reason
						// Update the affected Branch entities in the cache
						// Not affected by multiple Collections since Branch is normalized
						// cache.modify({
						// 	id: cache.identify({ __typename: 'Branch', ID: fromID }),
						// 	fields: {item: () => fromItem}
						// })
						// cache.modify({
						// 	id: cache.identify({ __typename: 'Branch', ID: toID }),
						// 	fields: {item: () => toItem}
						// })
						const collections = this.Cluster?.Collections || []
						collections.forEach( c => {
							const ClientBranches = c.Tree?.ClientBranches || []
							if (!ClientBranches.length) {
								return
							}
							const rootClientBranch = ClientBranches.find(cb => cb.path === '001') || ClientBranches[0]
							if (!rootClientBranch) {
								return
							}
							const branches = ClientBranches.map(cb => cb.Branch)
							this.modifyClientBranch({
								Branches: branches,
								Branch: rootClientBranch.Branch,
								Parent: rootClientBranch.parentCB || { ID: rootClientBranch.parentCB?.ID || '', path: rootClientBranch.parentCB?.path || '' },
								ClientBranches: ClientBranches
							})
						})
					}
				})
			},
			createClientBranch(vars){
				const {Branches, Branch, Parent, ClientBranches, draft, query} = vars
				// console.log('createClientBranch -', vars)
				// note:  Parent will be a ClientBranch object except when Root
				// in the Root case, it will have only ID, childCount, path fields
				// recursuve method to create one or more ClientBranches
				// the ClientBranches argument is an external array that will collect each ClientBranch as it is created
				// find all the Branches that share the parent of this Branch
				let children = Branches.filter(b => Branch.Child.ID == b.Parent.ID)
				let childCount = children.length
				const path = (Parent.path == '') ? '001'  :  Parent.path + "." + ("00" + Branch.item).slice(-3)
				// path (001.002) is divisible by 4
				// need to add 1 to path length because there is no '.' on end of a path
				let indent = ((path.length + 1) / 4) -1  // remove 1 so Root indent = 0
				let parentCB = {
					ID:Parent.ID,
					path:Parent.path,
					isCollection:Parent.isCollection,
				}
				var filterInstance = {}
				if(!_.isEmpty(query)){
					if(path == '001'){
						filterInstance = query.RootInstance
										}else{
						const match = query.iBranches?.find(q=> q.Branch.ID == Branch.ID && q.Child.value)
						filterInstance = match?match.Child:{}
					}
				}
				let digests = children.filter(c => c.digest)
				// assemble the ClientBranch Object
				let ClientBranch = {
					__typename:"ClientBranch",
					ID: uuidv4(), // a unique ID for this local branch
					parentCB: parentCB,
					Branch: Branch,
					// childCount: childCount,
					digests:digests,
					draft: draft?draft:false,
					indent: indent,
					path: path,
					filter:{
						buffer:'',
						Instance:filterInstance,
						request:'',
					},
					request:{
						buttons:[],
						req: '',
						mode:'',
						nod:{},
						tree:{}
					},
					display: '0000',
					config:false,
					isVisible: Parent?.showChildren==undefined?true:Parent.isVisible?Parent.showChildren:false,
					showChildren: Parent?.showChildren==undefined?true:Parent.showChildren,
					editBBuffer: draft?'sss':'',
					tools:{
						branch:[
							['X','X',0,0], 		// cancel
							['/'+'\\','-',1,0],	// down
							['\\'+'/','+',1,0],	// up   
							['+','A',1,0], 		// add
							['-','R',1,0], 		// remove
							['V','V',1,0], 		// visibility
							['A','N',1,0], 		// NickName - Alias
						],
						digest:[
							['X','X',0,0], 			// branch tool is active
							['/'+'\\','-',1,0],	// down
							['\\'+'/','+',1,0],	// up   
							['+','A',1,0], 			// add
							['R','R',1,0] 			// remove
						],
						filter:false,name:false
					}
				}
				// console.log(ClientBranch.filter.Instance.value)
				// add the ClientBranch to the ClientBranches array
				ClientBranches.push(ClientBranch)
				// if there are children then make a ClientBranch for each of them
				if (childCount > 0){
					children.map(b => {
						const vars = {
							Branches:Branches,
							Branch:b,
							Parent:ClientBranch,
							ClientBranches:ClientBranches,
							query:query
						}
						this.createClientBranch(vars)
					})
				}
			},
			images(Cluster){
				const showImages = !Cluster.showImages
				client.writeFragment({
					id: 'Cluster:{"ID":"' + Cluster.ID + '"}',
					fragment: ShowImagesFragment,
					fragmentName: 'ShowImagesFragment',
					data: {showImages: 	showImages}
				})
			},
			createCluster(){
				// console.log('createCluster')
				// the container object for all Collection objects
				// this only run once, the first time a colelction is added
				if(_.isEmpty(this.Cluster)){
					const cluster = {
						ID:uuidv4(),
						__typename:"Cluster",
						editMode:2,
						Collections:[],
						showImages:false
					}
					// console.log(cluster)
					client.writeQuery({
						query: addCluster,
						fragmentName: addCluster,
						data: {Cluster: cluster},
					})
				}
			},
			addCollection(vars){
				const {rootInstanceID, parentCollectionID, ClientInstance, query, rootNod} = vars
				// console.log('addCollection -', vars )
				// if ClientInstance is provided, then this Collection is for use with the modal component SelectInstance.vue
				const collectionID = uuidv4()
				// the new Collection
				const Collection = {
					__typename:"Collection",
					ID:collectionID,
					enableEdit: true, // this.Cluster.editMode>0?false:true,
					editMode:2,
					selectedInstanceIDs: [], // Initialize persistent selection storage
					modalVars:{
						parentCollectionID:'',
						rootInstanceID:'',
						ClientInstance:{},
						selectedInstances:[]
					},
					rootInstanceID:rootInstanceID?rootInstanceID:'',
					flags:{
						activeQuery:query?query:{},
						clickToFilter:true,
						filterSelection:false,
						queryIsStale:false
					},
					useFilters:query?true:false,
						pageVars:{offset:0},
					Root:rootNod?rootNod:{
						__typename:"Nod",
						ID: "",
						name:"",
						created:null,
						isCollection:true
					},
					Tree:{
						__typename:"Tree",
						ID: uuidv4(),
						branchIsStale: false,
						ClientBranches:[],
						treeFlags:[],
						treeIsStale:false
					},
					ITrees:{
						__typename:"ITrees",
						ID: uuidv4(),
						ITrees:[],
						iTreeIsStale: false,
					},
					editITree:{
						__typename:"ITrees",
						ID: uuidv4(),
						ITrees:[],
						iTreeIsStale: false,
					},
				}
				const ClusterID = 'Cluster:{"ID":"' + this.Cluster.ID + '"}'
				client.writeFragment({
					id: ClusterID,
					fragment: UpdateCollectionsFragment,
					fragmentName: 'UpdateCollectionsFragment',
					data: {Collections: Collection}
				})
				if(ClientInstance){
					const modalVars = {
						rootInstanceID:_.isEmpty(rootInstanceID)?'':rootInstanceID,
						parentCollectionID: _.isEmpty(parentCollectionID)?'':parentCollectionID,
						ClientInstance:ClientInstance,
						selectedInstances:[]
					}
					client.cache.modify({
						id: client.cache.identify(Collection),
						fields: {
							modalVars() {return modalVars}
						}
					})
				}
			},
			callModalCollection(vars){
				// console.log('callModalCollection -', vars)
				//this will create a new collection with Collection.modalVars.CollectionID = to the Collection ID that called it.

				const {
					rootNod, // root node
					rootInstanceID,// the root(parent) Instance.ID that will receive the selectedInstances.  Will be '' when creating a new Instance
					parentCollectionID, // the Collection object that the modal Collection was called from
					ClientInstance, // this ClientInstance called the modal collection
					// selectedInstances, // array of instances that were selected (checked) at time of "Done" click
					state // true-create modalCollection, false-destroy modalCollection
				} = vars
				// const parentCollection = this.Cluster.Collections.find(c => c.ID == parentCollectionID)
				if(state){
					const cVars = {
						rootNod:rootNod,
						rootInstanceID:rootInstanceID || "",
						parentCollectionID:parentCollectionID,
						ClientInstance:ClientInstance,
						query:{}
					}
					this.addCollection(cVars)
							
					// const newRoot = ClientInstance.ClientBranch.Branch.Child
					// const vars = {
					// 	Collection:newCollection,
					// 	rootNod:newRoot
					// }
					// this.setRoot(vars)
					// this.setTreeIsStale({treeID:newCollection.Tree.ID,state:true})
				}
				// if(!state){ // remove modalCollection
				// 	this.setRootInstanceID({
				// 		Collection:parentCollection,
				// 		rootID:rootInstanceID
				// 	})
				// }
			},
			removeCollection(vars){
				// console.log('removeCollection -', vars)
				const {CollectionID} = vars
				const Collection = this.Cluster.Collections.find(c => c.ID == CollectionID)
				// remove targetCollection from array
				const newCollections = this.Cluster.Collections.filter(c=> c.ID !== CollectionID)
				//  Update Cluster.Collections array
				client.writeFragment({
					id: 'Cluster:{"ID":"' + this.Cluster.ID + '"}',
					fragment: UpdateCollectionsFragment,
					fragmentName: 'UpdateCollectionsFragment',
					data: {Collections: newCollections},
				})
				this.purgeCollection({Collection:Collection,removeCollection:true})
			},
			setRoot(vars){
				const {Collection, rootNod} = vars
				// console.log('setRoot -', vars)
				const Root = Collection.Root
				if (Root.name !== rootNod.name){
					this.toggleSelections	({Collection:Collection, state:false})
					this.setActiveQuery		({Collection:Collection, state:false})
					client.cache.modify({
						id: client.cache.identify(Collection),
						fields: {
							Root(existing, { toReference }) {
								return toReference(rootNod);
							}
						}
					})
					this.selectRoot = false
					this.activeChild = false
				}
			},

			// FILTERS
			setUseFilters(vars){
				const {Collection,state} = vars
				const currentState = Collection.useFilters
				if (currentState!== state){
					// console.log('setUseFilters -', state)
					client.cache.modify({
						id: client.cache.identify(Collection),
						fields: {
							useFilters() { return state }
						}
					})
				}
			},
			filtersObjCreate(query){
				// console.log('filtersObjCreate -', query)
				// from the server ITree object, prepare filter objects to merge with ClientBranches
				if(!_.isEmpty(query)){
					const filters = []
					const iBranches = query.iBranches
					const rootIBranch = {Branch:{item:'1'},Child:query.RootInstance}
					this.makePath(filters,iBranches,rootIBranch,'001')
					return filters
				}else{
					return []
				}
			},
			updateCBFilter(vars){
				// console.log('Cluster - updateCBFilter -', vars)
				let {  ClientBranch, Instance, Collection } = vars
				
				// RENAME LOGIC: If this is the root filter and we have an active query,
				// we should update the active query's name instead of creating a new one.
				if (ClientBranch.path === '001' && Collection?.flags?.activeQuery?.ID) {
					const activeQuery = Collection.flags.activeQuery;
					// If the new instance has a different ID than the active query,
					// we "adopt" the active query's ID but use the new value.
					if (Instance.ID !== activeQuery.RootInstance.ID) {
						Instance = {
							...Instance,
							ID: activeQuery.RootInstance.ID
						};
					}
				}

				const filterVars = {
					ClientBranch: ClientBranch,
					filter:{
						buffer:'',
						Instance: Instance,
						request:''
					}
				}
				client.writeFragment({
					id: client.cache.identify(filterVars.ClientBranch),
					fragment: setFilter,
					fragmentName: 'setFilter',
					data: {filter: filterVars.filter},
				})
			},
			//QUERIES
			
			addQuery(qvars){
				// console.log ('addQuery -', qvars)
				const {collection} = qvars
				// first examine ClientBranches and add missing parent(s) if necessary
				const ClientBranches = collection.Tree.ClientBranches
				// this.ensureParentInstances(collection.Tree.ClientBranches)
				// must process collections from bottom to top of tree
				const collectionClientBranches = _.orderBy(ClientBranches.filter(cB => cB.Branch.Child.isCollection),'path','desc')
				const Filters = []
				collectionClientBranches.map(cB => collectionFilterInstance(cB))
				// for ClientBranches that are Collections
				function collectionFilterInstance(ClientBranch){
					const path = ClientBranch.path
					// console.log(path)
					const parentInstance =
						path == '001'?
						// a level 2 collection
						{
							ID:ClientBranch.filter.Instance.ID,
							isFilter:ClientBranch.filter.Instance.isFilter,
							value:ClientBranch.filter.Instance.value,
							isPinned:ClientBranch.filter.Instance.isPinned}
						// greater than level 2 collection
						:{
							ID:uuidv4(),
							isFilter:true,
							value:null,
							isPinned:false
						}
					const pathLen = path.length
					var children = ClientBranches.filter(cB => 
						cB.path.substring(0,pathLen) == path // all paths that match ClientBranch.path 
						&&
						cB.path.length == pathLen + 4 // and tree.path length is one level > path 
					)
					// accumulate the children
					const childObj = []
					// child leaves
					var childLeaf = children.filter(c=> !c.Branch.Child.isCollection)
					childLeaf.map(cL=> {
						if(!_.isEmpty(cL.filter.Instance)){
							const childLeaf = { // child that is a leaf
								path:cL.path,
								nodID:cL.Branch.Child.ID,
								Instance:{
									ID:cL.filter.Instance.ID,
									isFilter:cL.filter.Instance.isFilter,
									value:cL.filter.Instance.value,
									isPinned:cL.filter.Instance.isPinned
								}
							}
							childObj.push(childLeaf)
						}
					})
					// child collections
					var childCollection = children.filter(c=> c.Branch.Child.isCollection)
					childCollection.map(cC=>{
						// look for this collection in previous results
						const collectionInstance = Filters.find(f => f.path == cC.path)
						if(collectionInstance){
							const i = collectionInstance.Instance
							const childCollection = { // child that is a collection
								path:cC.path,
								nodID:cC.Branch.Child.ID,
								Instance:{ID:i.ID,isFilter:i.isFilter,value:null,isPinned:false},
							}
							childObj.push(childCollection)
						}
					})
					// this collection
					if(!_.isEmpty(childObj)){
						const collection = {
							path: ClientBranch.path,
							nodID:ClientBranch.Branch.Child.ID,
							Instance:parentInstance,
							children:childObj
						}
						Filters.push(collection)
					}
				}
								// must provide filters from top to bottom of tree
				// try  reversing order
				Filters.reverse()
					let vars = {
						userID:this.authStatus.userID,
						filters: Filters,
					}
				// console.log('addQuery Mutation Vars: ', vars)
				// list parameters in format suitable for Neo4j browser
				// const jsonString = JSON.stringify(vars,null,2);
				// console.log(':param ' + jsonString.replace(/"([^"]+)"\s*:/g, '$1:'))

				this.$apollo.mutate({
					mutation: AddQueryMutation,
					variables: vars,
				})
				.then ((data)=>{
					// console.log('addQuery Mutation Return Vars: ', data.data.AddQuery)
					this.$apollo.queries.Queries.refetch()
					// AddQuery returns an array, take the first item
					const newQuery = data.data.AddQuery[0]
					this.setActiveQuery({Collection:collection, query:newQuery})
				})
				.catch(error =>{ // oops!
					console.log('AddQuery ' + error)
				})
			},
			clusterQueryHandler(vars){
				let {rootNod, query, Op} = vars
				// console.log('clusterQueryHandler -', vars)
				// handle query selection at the Cluster level
				// therefor only the first item in the array
				const Collection = this.Cluster.Collections[0]
				// console.log('clusterQueryHandler -', Collection)

				switch (Op){
					case 0:{ // load a query
						if(!Collection){
							this.addCollection({
								rootNod:rootNod,
								query: query,
							})
						}else{
							// console.log(Collection.Root.name !== rootNod.name)
							if(Collection.Root.name !== rootNod.name){
								this.setRoot({Collection:Collection,rootNod:rootNod, query:query})
							}
							const queryVars = {
								Collection:Collection,
								query:query,
								Op:0
							}
							// console.log('queryVars: ' , queryVars)
							this.queryHandler(queryVars)
						}
						this.queryButtonMode = 0
					}
					break
					case 3:{  // unpin a query
						this.queryHandler({
							Collection:{},
							query:query,
							Op:3
						})
						this.queryButtonMode = 0
					}
					break
				}
			},
			deleteQuery(queryID){
				// console.log('deleteQuery -', queryID)
				// remove isPinned from ClientBranches[0].filter Instance\
				// this really needs to be removed from cache
				const ID = 'Instance:{"ID":"' + queryID + '"}'
				client.writeFragment({
					id: ID,
					fragment: isPinned,
					fragmentName: 'isPinned',
					data: {isPinned: false},
				})
				let vars = {
					rootInstanceID:queryID//collection.Tree.ClientBranches[0].filter.Instance.ID
				}
				this.$apollo.mutate({
					mutation: DeleteQueryMutation,
					variables: vars,
				})
				.then (()=>{
					this.$apollo.queries.Queries.refetch()
				})
				.catch(error =>{ // oops!
					console.log('DeleteQuery ' + error)
				})
			},
			loadQuery(vars){
				// console.log('loadQuery -', vars)
				// insert query values into existing ClientBranches
				const {Collection, query} = vars
				const filters = this.filtersObjCreate(query)
				const ClientBranches = Collection.Tree.ClientBranches
				ClientBranches.map(cB => {
					// find a filter for this ClientBranch
					const newFilter = filters.find(f => f.path === cB.path && (cB.path === '001' || f.branchID === cB.Branch.ID))
					// console.log('newFilter' + newFilter)
					if(!_.isEmpty(newFilter) && !_.isEmpty(cB.filter)) {
						// apply the filter
						this.updateCBFilter({
							// Collection:Collection,
							ClientBranch:cB,
							Instance:newFilter.filter
						})
					}else{
						if(!_.isEmpty(cB.filter.Instance)){
							// apply an empty filter
							this.updateCBFilter({
								// Collection:Collection,
								ClientBranch:cB,
								Instance:{}
							})
						}
					}
				})
			},
			pinQuery(query,state){
				// console.log('pinQuery -',state)
				let vars = {
					queryID:query.RootInstance.ID,
					state:state
				}
				// list parameters in format suitable for Neo4j browser
				// const jsonString = JSON.stringify(vars,null,2);
				// console.log(':param ' + jsonString.replace(/"([^"]+)"\s*:/g, '$1:'))
				this.$apollo.mutate({
					mutation: PinQueryMutation,
					variables: vars,
				})
				.then (()=>{
					this.$apollo.queries.Queries.refetch()
				})
				.catch(error =>{ // oops!
					console.log('PinQuery ' + error)
				})
			},
			queryHandler(vars){
				let {Collection,query,Op} = vars
				// console.log('queryHandler -', vars)
				this.setCollectionEditMode(Collection,2)
				switch(Op){
					case 0: {// a query has been requested
						this.setUseFilters({Collection:Collection,state:true})
						this.setActiveQuery({Collection:Collection,query:query})
						// Reload if it's a different query OR if the current one is stale
						if(query.RootInstance.ID !== Collection.flags.activeQuery?.RootInstance?.ID || Collection.flags.queryIsStale){
							this.loadQuery({Collection:Collection,query:query})
						}
					}
					break
					case 1: // delete the query
						this.deleteQuery(query.RootInstance.ID)
					break
					case 2: // pin the query
						this.pinQuery(query,true)
					break
					case 3: // unPin the query
						this.pinQuery(query,false)
						this.queryButtonMode = 0
					break
				}
			},
			toggleClickToFilter(vars){
				const {Collection, state} = vars
				// toggle Collection.flags.clickToFilter
				const currentState = Collection.flags.clickToFilter
				if(currentState !== state){
					// console.log('toggleClickToFilter -', state)
					client.cache.modify({
						id: client.cache.identify(Collection),
						fields: {
							flags(existingFlags) {
								return { ...existingFlags, clickToFilter: state }
							}
						}
					})
				}
			},
			toggleSelections(vars){
				// console.log('toggleSelections ' , vars)
				const {Collection, state} = vars
				const currentState = Collection.flags.filterSelection
				if (currentState !== state){
					client.cache.modify({
						id: client.cache.identify(Collection),
						fields: {
							flags(existingFlags) {
								return {
									...existingFlags,
									filterSelection: state
								}
							}
						}
					})
				}
			},
			setActiveQuery(vars){
				const {Collection,query} = vars
				// console.log('setActiveQuery -' , vars)
				// const queryString = _.isEmpty(query)?'{}':query.RootInstance.value
				// query is an object
				// if there is a Query then turn on Collection.useFilters
				// this.setUseFilters({Collection:Collection,state:true})
				const activeQuery = _.isEmpty(query) ? {} : query
				client.cache.modify({
					id: client.cache.identify(Collection) || `Collection:{"ID":"${Collection.ID}"}`,
					fields: {
						flags(existingFlags) {
							return {
								...existingFlags,
								activeQuery: activeQuery,
								queryIsStale: false
							}
						},
						useFilters() { return !_.isEmpty(query) }
					}
				})
			},		
			setQueryIsStale(vars){
				//  console.log('setQueryIsStale -', vars)
				// set queryIsStale flag for a Collection	
				// when true, the iCollection query will be re-run
				// console.log('setQueryIsStale -', vars)
				const {Collection,state} = vars
				client.cache.modify({
					id: client.cache.identify(Collection) || `Collection:{"ID":"${Collection.ID}"}`,
					fields: {
						flags(existingFlags) {
							return { ...existingFlags, queryIsStale: state }
						}
					}
				})
			},
			// ClientBranch Mutations
			async updateBranchAlias(vars){
				// console.log('updateBranchAlias ' , vars)
				const {ClientBranch, alias } = vars
				const updateBranchVars = {ID: ClientBranch.Branch.ID, alias: alias}
				// list parameters in format suitable for Neo4j browser
				// const jsonString = JSON.stringify(updateBranchVars,null,2);
				// console.log(':param ' + jsonString.replace(/"([^"]+)"\s*:/g, '$1:'))
				try {
					await this.$apollo.mutate({
						mutation: UpdateBranchAlias,
						variables: updateBranchVars
					})
				} catch (error) {
					console.error('Update Branch Alias Error:', error)
				}
			},
			async hideBranch(vars) {
				// console.log('hideBranch :', vars)
				const { ClientBranch, isHidden } = vars
				const branchID = ClientBranch.Branch.ID
				// Server stores hidden as true | null
				const newState = isHidden === true ? null : true
				// console.log('hideBranch :', newState)
				const hideBranchVars = {branchID, isHidden: newState}
				// const jsonString = JSON.stringify(hideBranchVars,null,2);
				// console.log(':param ' + jsonString.replace(/"([^"]+)"\s*:/g, '$1:'))
				try {
					await this.$apollo.mutate({
						mutation: HideBranchMutation,
						variables: hideBranchVars,
						update: (cache) => {
							// 1) Update the normalized Branch entity
							try {
							const cacheId = client.cache.identify({ __typename: 'Branch', ID: branchID })
							client.cache.modify({
								id: cacheId,
								fields: {
									isHidden() {
										return newState
									}
								}
							})
							} catch (e) {
							console.error('hideBranch: cache modify failed', e)
							}

							// 2) Keep getBranch query arrays in sync across collections (if present in cache)
							const collections = this.Cluster?.Collections || []
							collections.forEach(c => {
								const variables = { root: c.Root.name }
								try {
									const prev = cache.readQuery({ query: getBranch, variables })
									if (prev?.Branches) {
									const next = prev.Branches.map(b =>
										b.ID === branchID ? { ...b, isHidden: newState } : b
									)
									cache.writeQuery({ query: getBranch, variables, data: { Branches: next } })
									}
								} catch {
									// Query may not be in cache yet — safe to ignore
								}
							})
						}
					})
				} catch (error) {
					console.error('Hide Branch Error:', error)
				}
			},
			async addBranch(vars) {
				// console.log('AddBranch ', vars)
				try {
					const { ClientBranch, nod } = vars
					const AddBranchVars = {
						// Create child?
						createChild: !nod.ID,
						// Child info
						childID: !nod.ID ? uuidv4() : nod.ID,
						childName: nod.name,
						isHidden: false,
						isCollection: Boolean(nod.isCollection),
						// Branch info
						branchID: ClientBranch.Branch.ID,
						branchItem: String(ClientBranch.Branch.item),
						// Parent info
						parentID: ClientBranch.Branch.Parent.ID
					}
					// console.log ('AddBranch Mutation Vars: ', AddBranchVars)
					// const jsonString = JSON.stringify(AddBranchVars,null,2);
					// console.log(':param ' + jsonString.replace(/"([^"]+)"\s*:/g, '$1:'))
					const { data } = await client.mutate({
						mutation: AddBranchMutation,
						variables: AddBranchVars,
						update: (cache, { data: { AddBranch: newBranches } }) => {
							// Update cache for each collection
							this.Cluster.Collections.forEach(collection => {
								try {
									const query = getBranch
									const variables = { root: collection.Root.name }
									// Read current cache
									const cacheData = cache.readQuery({query,variables})
									const existingBranches = cacheData?.Branches ?? []
									// Merge new branches with existing ones, avoiding duplicates
									const updatedBranches = [...existingBranches]
									// console.log(updatedBranches)
									// console.log(newBranches)
									newBranches.forEach(newBranch => {
										const existingIndex = updatedBranches.findIndex(
											existing => existing.ID === newBranch.ID
										)
										if (existingIndex === -1) {
											updatedBranches.push(newBranch)
										}
									})
									// Write updated data back to cache
									cache.writeQuery({
										query: getBranch,
										variables:variables,
										data: { Branches: updatedBranches }
									})
									// console.log('updatedBranches ', updatedBranches)
									// Get an array of parent ClientBranches
									const parentClientBranches = collection.Tree.ClientBranches
										.filter(cB => cB.Branch.Child.ID === newBranches[0].Parent.ID)
									// Now call creatClientBranch with the new branches
									const newClientBranches = []
									parentClientBranches.forEach(parentClientBranch => {
										this.createClientBranch({
											Branches: newBranches,
											Branch: newBranches[0],
											Parent: parentClientBranch,
											ClientBranches: newClientBranches,
											draft: false,
											query: {}
										})
									})
									const treeID = 'Tree:{"ID":"' + collection.Tree.ID + '"}'
									const existingClientBranches = collection.Tree.ClientBranches

									client.writeFragment({
										id: treeID,
										fragment: UpdateBranchFragment,
										fragmentName: 'UpdateBranchFragment',
										data: {ClientBranches: [...existingClientBranches, ...newClientBranches]}
									})

								} catch (cacheError) {
									console.error('Cache update error for collection:', collection.Root.name, cacheError)
								}
							})
						}
					})
					return data.AddBranch
				} catch (error) {
					console.error('Add Branch Error:', error)
					throw error
				}
			},
			removeBranch(vars) {
				const { ClientBranch } = vars;
				const parentID = ClientBranch.Branch.Parent.ID;
				const branchID = ClientBranch.Branch.ID;
				const variables = { parentID, branchID };
				// console.log('removeBranch ', variables);
				// const jsonString = JSON.stringify(variables,null,2);
				// console.log(':param ' + jsonString.replace(/"([^"]+)"\s*:/g, '$1:'))

				this.$apollo.mutate({
					mutation: RemoveBranch,
					variables: variables,
					update: (cache, { data }) => {
						const result = data?.RemoveBranch;
						if (!result) return;
						// For each Collection in the Cluster
						this.Cluster.Collections.forEach(c => {
							// console.log('Updating Collection: ', c.Root.name);
							const ClientBranches = c.Tree.ClientBranches;
							const parentsCBToRemove = ClientBranches.filter(pCB => pCB.Branch.ID == branchID)
							const childrenCBToRemove = parentsCBToRemove.flatMap(p =>
								ClientBranches.filter(cB =>
									// include all descendants (if any) of each parent path
									cB.path.startsWith(p.path + '.')
								)
							)
							const allcBToRemove = [parentsCBToRemove, childrenCBToRemove].flat() // all cB to remove
							const newCB = ClientBranches.filter(cB =>  // cB remaining
								!allcBToRemove.some(r => r.path === cB.path)
							)
							// Update the Tree.ClientBranches arrayOld
							const treeID = client.cache.identify({ __typename: 'Tree', ID: c.Tree.ID })
							client.writeFragment({
								id: treeID,
								fragment: UpdateBranchFragment,
								fragmentName: 'UpdateBranchFragment',
								data: {ClientBranches: newCB}
							})
						})
					},
				})
				.catch(error => {
					console.log("Remove Branch Error: " + error);
				});
			},
			updateBranch(vars){
				// edit the text of a Nod
				// console.log('updateBranch -', vars)
				const {ClientBranch, nod, Collection} = vars
				this.$apollo.mutate({
					mutation: UpdateNod,
					variables: {
						ID: ClientBranch.Branch.Child.ID,
						name: nod.name
					},
					update: (cache) => {
						// For each collection that might have this branch
						const allCollections = this.Cluster.Collections
						allCollections.forEach(c => {
							const query = getBranch
							const variables = { root: c.Root.name }
							try {
								// Read the existing branches from cache
								const data = cache.readQuery({ query, variables })
								if (data?.Branches) {
									// Create new branches array with updated node
									const updatedBranches = data.Branches.map(branch => {
										if (branch.Child.ID === nod.ID) {
											return {
												...branch,
												Child: {
													...branch.Child,
													name: nod.name
												}
											}
										}
										return branch
									})
									// Write back to cache
									cache.writeQuery({
										query,
										variables,
										data: { Branches: updatedBranches }
									})
								}
							} catch (e) {
								console.log('Cache update error:', e)
							}
						})
					}
				})
				.catch(error => {
					console.log("Update Nod Error: " + error)
				})
				this.callTool( {ClientBranch:ClientBranch,tool:'branch',state:false,Collection:Collection})
				this.editBBuffer({ClientBranch:ClientBranch,name:''})
			},
			deleteNod(vars){
				// console.log('deleteNod -', vars)
				const {Collection,ClientBranch,tree} = vars
				// delete the unused Nod
				this.$apollo.mutate({
					mutation: DeleteNod,
					variables: {ID:ClientBranch.Branch.Child.ID},
				})
				.then (()=>{
				})
				.catch(error =>{console.log("Remove Branch Error: " + error)})
				this.updateTrees({
					crudOp:'delete',
					Branch:ClientBranch.Branch,
					data: tree,
					Collection:Collection
				})
				this.callTool( {ClientBranch:ClientBranch,tool:'branch',state:false,Collection:Collection})
				this.editBBuffer({ClientBranch:ClientBranch,name:''})
			},
			// CREATE BRANCH/TREE
			createTree(vars){
				// console.log('createTree', vars)
				const {Collection, Branches, root, query, operation} = vars
				if(!_.isEmpty(Branches) && operation == 'create'){
					const Root = {
						__typename:"Branch",
						Child: root,
						ID: uuidv4(),
						created: null,
						item: '1',
						digest: null,
						isHidden: null,
						alias:'',
						Parent: {}
					}
					const Parent = {
						ID:uuidv4(),
						path:'',
						isCollection:false,
						__typename:'ClientBranch'
					}
					const CB = []
					const cBvars = {
						Branches:Branches,	
						Branch:Root,
						Parent:Parent,
						ClientBranches:CB,
						query: query
					}
					this.createClientBranch(cBvars)
					const ClientBranches = _.orderBy(CB, 'path', 'asc')
					const treeID = 'Tree:{"ID":"' + Collection.Tree.ID + '"}'
					client.writeFragment({
						id: treeID,
						fragment: UpdateBranchFragment,
						fragmentName: 'UpdateBranchFragment',
						data: {ClientBranches: ClientBranches}
					})
				}
			},
			addClientBranch(vars){
				const {Branch,Branches,parentClientBranch,treeID, query} = vars
				// console.log('addClientBranch -', vars)
				// adds a temp ClientBranch when performing AddBranch
				const ClientBranches = []
				const cBvars = {
					Branches:Branches,
					Branch:Branch,
					Parent:parentClientBranch,
					ClientBranches:ClientBranches,
					draft:true,
					query:query
				}
				this.createClientBranch(cBvars)

				const ID = 'Tree:{"ID":"' + treeID + '"}'
				const existingClientBranches = cache.readFragment({
					id: ID,
					fragment: UpdateBranchFragment,
					fragmentName: 'UpdateBranchFragment',
				})?.ClientBranches || [];
				const newClientBranches = [...existingClientBranches, ...ClientBranches];

				client.writeFragment({
					id: ID,
					fragment: UpdateBranchFragment,
					fragmentName: 'UpdateBranchFragment',
					data: {ClientBranches: _.orderBy(newClientBranches, 'path', 'asc')},
				})
				
			},
			deleteClientBranch(vars){
				// console.log('deleteClientBranch', vars)
				const{ Collection, ClientBranch } = vars
				// delete ClientBranch from Tree.ClientBranches
				// and get rid of it from the cache
				const newTree = Collection.Tree.ClientBranches.filter(cb => cb.ID !== ClientBranch.ID)
				
				client.writeFragment({
					id: 'Tree:{"ID":"' + Collection.Tree.ID + '"}',
					fragment: UpdateBranchFragment,
					fragmentName: 'UpdateBranchFragment',
					data: {ClientBranches: newTree},
				})
				cache.evict({ 
					id: cache.identify({
						__typename: "Nod",
						ID: ClientBranch.Branch.Child.ID
					})
				});
				cache.gc();
			},
			// Request/Response
			clientInstanceRequest(vars) {
				// console.log('clientInstanceRequest', vars)
				const { ClientInstance, action, Instance, item } = vars;
				const targetInstance = Instance || item;
				let req = '';
				let buttons = ['N', 'Y'];

				if (action === 'addNewInstance') {
					targetInstance.created = new Date().toISOString();
					targetInstance.ID = uuidv4();
				}
				switch (action) {
					case 'addExistingInstance':
						req = `Add existing "${targetInstance.value}"?`;
						break;
					case 'addNewInstance':
						req = `Create and add "${targetInstance.value}"?`;
						break;
					case 'removeClientInstance':
						req = `Remove "${targetInstance.value}"?`;
						break;
					case 'updateInstanceValue':
						req = `Replace "${ClientInstance.iBranch.Child.value}" with "${targetInstance.value}"?`;
						break;
					case 'deleteOrphanedInstance':
						req = `"${targetInstance.value}" IS NOT USED elsewhere. Delete it?`;
						break;
					case 'doNothing':
						req = `"${targetInstance.value}" IS USED elsewhere. Cannot delete`;
						buttons = ['OK'];
						break;
				}
				client.writeFragment({
					id: `ClientInstance:{"ID":"${ClientInstance.ID}"}`,
					fragment: clientInstanceRequest,
					fragmentName: 'clientInstanceRequest',
					data: {
						clientInstanceRequest: {
							buttons,
							mode: action,
							Instance: targetInstance,
							req
						}
					}
				});
				this.editBuffer({ ClientInstance, state: "00010" });
			},
			clientInstanceResponse(responseVars){
				// console.log('clientInstanceResponse', responseVars)
				let exitResponse = false
				const {CollectionID, ClientInstance, action, response, Instance} = responseVars
				if (response == 'Y'){
					const hasParent = !_.isEmpty(ClientInstance.parentInstance)
					var vars = {
						CollectionID:CollectionID,
						ClientInstance:ClientInstance,
						Instance:Instance
					}
					if (action == 'addExistingInstance')	{vars.mutationCode = hasParent?'0.1.1.2':'1.1.1.2'}// existing:add parent
					if (action == 'addNewInstance')			{vars.mutationCode = hasParent?'0.1.1.3':'1.1.1.3'}// existing:add parent
					if (action == 'updateInstanceValue')	{
						vars.mutationCode = '0.1.0.1';
						exitResponse = true
					}
					if (action == 'removeClientInstance')	{vars.mutationCode = '0.0.1'}
					if (action == 'deleteOrphanedInstance')	{vars.mutationCode = '0.0.0'}
					this.callInstanceMutation(vars)
				}
				if (response =='OK' || response == 'N' || exitResponse){
					this.editBuffer({ClientInstance:ClientInstance,state:"00100"})
					this.activeChild = false
				}
			},
			editBuffer(vars){
				// console.log('editBuffer -', vars)
				// for editing an Instance item
				// use this string to determine which components to display
				//   1      1       1      1         1
				// Cancel Remove Default Request AutoComplete  	
				const {ClientInstance,state} = vars


				const ID ='ClientInstance:{"ID":"' + ClientInstance.ID + '"}'
				client.writeFragment({
					id: ID,
					fragment: editBuffer,
					fragmentName: 'editBuffer',
					data: {editBuffer: state},
				})
			},
			// Instance Mutations
			callInstanceMutation (vars){
				// console.log('callInstanceMutation', mutationCode)
				// depending on the mutation you will be redirected 
				const{CollectionID, ClientInstance, Instance, mutationCode} = vars
				const Collection = this.Cluster.Collections.find(c => c.ID == CollectionID)
				// console.log('callInstanceMutation ', vars)
				// 			[relations]   [function]   
				// [parent-child].[create-destroy].[yes-no].[edit-existing-new]
				//      [1-0]    .     [1-0]      .  [1-0] .      [1-2-3]
				// call the appropriate mutation
				switch(mutationCode) {
					// *** DESTROY ***
					case '0.0.0': // delete an orphaned Instance
						this.deleteInstance(vars)
						break
					case '0.0.1': // remove the CHILD_OF_INSTANCE relationship that connects this Instance to its parent Instance
						this.removeIBranch(ClientInstance)
						break
					case '1.0.1': // Delete a Collection Instance and remove all of its iBranches
						this.deleteCollectionInstance(ClientInstance)
						break
					// *** CREATE ***
					case '0.1.0.1': // Edit Instance.value
						this.updateInstance(Instance)
						break
					case '0.1.1.2': // Add an existing Instance leaf
						{
							const instanceID = Instance.ID
							this.addIBranch(Collection,ClientInstance, instanceID)
						}
						break	
					case '0.1.1.3': // Create and add a new Instance leaf
						this.addNewIBranch(ClientInstance,Instance)
						break
					case '1.1.1.2': // Create a new Parent and Add an existing Instance leaf
						this.addIBranchAndParent(CollectionID,ClientInstance,Instance)
						break
					case '1.1.1.3': // Create a new Parent and add a new Instance leaf
						this.addNewIBranchAndParent(CollectionID,ClientInstance,Instance)
						break
				}
			},
			// 0.0.0 deleteInstance
			deleteInstance(vars){
				const {ClientInstance} = vars
				// console.log('0.0.0 deleteInstance', ClientInstance)
				// delete an Instance that has no relationships
				const Vars = {
					ID: ClientInstance.iBranch.Child.ID
				}
				this.$apollo.mutate({
					mutation: DeleteInstanceMutation,
					variables: Vars,
				})
				.then (()=>{
					this.activeChild = false
				})
				.catch(error =>{
					console.log('Delete Instance Error: ' + error)
				})
			},
			// 0.0.1 removeIBranch
			removeIBranch(ClientInstance){
				// remove an IBranch
				const iBranch = ClientInstance.iBranch
				const Instance = iBranch.Child
				const vars = {
					ID:ClientInstance.iBranch.ID
				}
				// console.log ('0.0.1 removeIBranch', vars)
				this.$apollo.mutate({
					mutation: RemoveIBranchMutation,
					variables: vars
				})
				.then (({data})=>{
					const result = data.RemoveIBranch
					const vars = {
						ClientInstance: ClientInstance,
						Instance: Instance,
						action: result.hasRels ? 'doNothing' : 'deleteOrphanedInstance'
					}
					this.clientInstanceRequest(vars)
				})
				.catch(error =>{
					console.log('Remove IBranch ' + error)
				})
			},
			// 1.0.1 deleteCollectionInstance
			deleteCollectionInstance(ClientInstance){
				// console.log ('1.0.1 deleteCollectionInstance', ClientInstance)
				const vars = {
					rootInstanceID: ClientInstance.iBranch.Child.ID
				}
				const Instance = ClientInstance.iBranch.Child
				this.$apollo.mutate({
						mutation: DeleteCollectionInstanceMutation,
						variables: vars,
				})
				.then (({data})=>{
					const result = data.DeleteCollectionInstance
					if(result.hasRels){
						const iVars = {
							ClientInstance:ClientInstance,
							request:{
								buttons:['OK'],
								Instance:{
									ID:Instance.ID,
									value:Instance.value,
									isPinned:Instance.isPinned?Instance.isPinned:false,
									isFilter:Instance.isFilter,
									created:Instance.created,
									__typename:Instance.__typename
								},
								mode:'OK',
								req:Instance.value + ' is used elsewhere. Cannot delete',
							}
						}
						this.clientInstanceRequest(iVars)
					}
				})
				.catch(error =>{
					console.log('Delete Collection Instance Error: ' + error)
				})
			},
			// 0.1.0.1 - updateInstance'
			updateInstance(Instance){
				// console.log('0.1.0.1 - updateInstance', Instance)
				const vars = {
					ID: Instance.ID,
					value: Instance.value
				}
				// console.log('0.1.0.1 updateInstance ', vars)
				this.$apollo.mutate({
					mutation: UpdateInstanceMutation,
					variables: vars
				})
				.then (()=>{
					// no need to do anything here
					// because the mutation will return an edited Instance that already exists in the cache
					// this.activeChild = false
					// this.setActiveRequest(false)
				})
				.catch(error =>{ // oops!
					console.log('Update Instance ' + error)
				})
			},
			// 0.1.1.2 addIBranch
			addIBranch(Collection,ClientInstance,instanceID){
				// add an existing child Instance  to an existing parent Instance
				let vars = {
					parentID: ClientInstance.parentInstance.ID,
					childID: instanceID,
				}
				// console.log('0.1.1.2 addIBranch ', vars)
				this.$apollo.mutate({
					mutation: AddIBranchMutation,
					variables: vars,
				})
				.then (()=>{// update the local data
					this.activeChild = false
				})
				.catch(error =>{
					console.log('AddIBranch ' + error)
				})
			},
			// 0.1.1.3 addNewIBranch
			addNewIBranch(ClientInstance, childInstance){
				// console.log('0.1.1.3 addNewIBranch', ClientInstance )
				// create a new Instance and add it to parentInstance
				let vars = {
					parentInstanceID: ClientInstance.parentInstance.ID,
					value: childInstance.value,
					childNodID: ClientInstance.ClientBranch.Branch.Child.ID
				}
				// console.log('0.1.1.3 addNewIBranch ', vars)
				this.$apollo.mutate({
					mutation: AddNewIBranchMutation,
					variables: vars,
				})
				.then (()=>{// update the local data
					this.activeChild = false
				})
				.catch(error =>{ // oops!
					console.log('addNewIBranch ' + error)
				})
				// this.activeChild = false
				// this.setActiveRequest(true)
			},
			// 1.1.1.2 addIBranchAndParent
			addIBranchAndParent(CollectionID,ClientInstance,childInstance){
				// create a parent Instance and add an existing child Instance
				let vars = {
					parentNodID:ClientInstance.ClientBranch.Branch.Parent.ID,
					childInstanceID: childInstance.ID,
				}
				// console.log('1.1.1.2 addIBranchAndParent', vars )
				this.$apollo.mutate({
					mutation: AddIBranchAndParentMutation,
					variables: vars,
				})
				.then (({data})=>{
					this.activeChild = false
					this.setRootInstanceID({
						CollectionID:CollectionID,
						rootID:data.AddIBranchAndParent.Parent.ID
					})
				})
				.catch(error =>{
					console.log('addIBranchAndParent ' + error)
				})
				this.activeChild = false
			},
			// 1.1.1.3	addNewIBranchAndParent
			addNewIBranchAndParent(CollectionID,ClientInstance,childInstance){
				// console.log('1.1.1.3	addNewIBranchAndParent', ClientInstance )
				// create a parent Instance and add an existing child Instance
				let vars = {
					BranchID:ClientInstance.ClientBranch.Branch.ID,
					value: childInstance.value,
				}
				// console.log('1.1.1.3 addNewIBranchAndParent ', vars)
				this.$apollo.mutate({
					mutation: AddNewIBranchAndParentMutation,
					variables: vars,
				})
				.then (({data})=>{
					this.setRootInstanceID({
						CollectionID:CollectionID,
						rootID:data.AddNewIBranchAndParent.Parent.ID
					})
					// this.activeChild = false
					// this.setActiveRequest(false)
				})
				.catch(error =>{
					console.log('addNewIBranchAndParent ' + error)
				})
				this.setActiveRequest(false)
				this.activeChild = false
			},
			callTool(vars){
				// console.log('callTool ', vars)
				// activate a tool and configure its buttons
				// [ 0   ,  0 ,   0  ,  0  ,  0  ]
				// [tool , up , down , add , remove]
				// extract args from vars
				const {ClientBranch,tool,state,Collection} = vars
				if(!this.activeChild && state){
					this.activeChild = true
				}
				let branchVis = _.cloneDeep(ClientBranch.tools.branch)
				let digestVis = _.cloneDeep(ClientBranch.tools.digest)
				let isCollection = _.cloneDeep(ClientBranch.Branch.Child.isCollection)
				let nameVis = null
				let filterVis = null
				const tools = ClientBranch.tools
				switch(tool){
					// Branch tools
					case 'branch':{
						// [symbol,code,visibility,selected]
						// console.log('callTool - branch')
						const isRoot 			= ClientBranch.path == '001'
						const item   			= ClientBranch.Branch.item
						// const branchCount = ClientBranch.parentCB.childCount
						const branchCount =
							Collection && Collection.Tree && Collection.Tree.ClientBranches ? 
							Collection.Tree.ClientBranches.filter(cB => 
								cB.parentCB.ID == ClientBranch.parentCB.ID
							).length : 0

						// console.log(item + ',' + branchCount)
						const isDraft = ClientBranch.draft // if draft then only cancel button is enabled
						branchVis[0][2] = state?1:0 // branch tool is active
						branchVis[1][2] = isDraft?0:1 < item?1:0 // down
						branchVis[2][2] = isRoot?0:isDraft?0:item<branchCount?1:0 // up
						branchVis[3][2] = isDraft || !isCollection || !ClientBranch.showChildren?0:1 // add if not a collection or children are hidden
						branchVis[4][2] = isDraft?0:isRoot?0:1 // remove
						branchVis[5][2] = isDraft?0: ClientBranch.Branch.Child.isCollection?0:1 // hidden
					}
					break
					// digest tools
					case 'digest':{
						// console.log('callTool - digest')
						const digest = ClientBranch.Branch.digest
						// count number of digest values for parent of this ClientBranch
						const digestCount = Collection.Tree.ClientBranches.find(pCB => pCB.ID == ClientBranch.parentCB.ID).digests.length
						digestVis[0][2] = state?1:0 // digest tool is active
						digestVis[1][2] = 1 < digest?1:0 // down
						digestVis[2][2] = digest?digest<digestCount?1:0:0 // up  cannot go up there is no digest  
						digestVis[3][2] = digest? 0 : 1 // add cannot add if there is already a digest
						digestVis[4][2] = digest? 1 : 0 // remove
					}
					break
					case 'name': {
						nameVis = state
					}
					break
					case 'filter': {
						// console.log('callTool - filter')
						filterVis = state
					}
					break
				}
				// assemble the tools object using a combination of exising and new 
				const data = {tools:{
					branch: _.isEmpty(branchVis) ? tools.branch : branchVis ,
					digest: _.isEmpty(digestVis) ? tools.digest : digestVis,
					name:   _.isNull(nameVis)	   ? tools.name   : nameVis,
					filter: _.isNull(filterVis)  ? tools.filter : filterVis
				}}
				client.writeFragment({
					id: client.cache.identify(ClientBranch),
					fragment: toolVis,
					fragmentName: 'toolVis',
					data: data,
				})
				this.activeChild = state
			},
			collectionEnableEdit(CollectionID,state){
				// set enableEdit of a Collection true/false
				let ID = 'Collection:{"ID":"' + CollectionID + '"}'
				client.writeFragment({
					id: ID,
					fragment: enableEdit,
					fragmentName: 'enableEdit',
					data: {enableEdit: state},
				}) 
			},
			purgeCollection(vars){
				const {Collection,removeCollection} = vars
				const orphans = []
				const Tree = Collection.Tree
				const ITrees = Collection.ITrees
				const editITree = Collection.editITree
				// start from parent objects in order to be able to remove the child objects after
				// i.e. cannot delet a child when a parent refers to it
				if(removeCollection){
					orphans.push('Collection:{"ID":"' + Collection.ID + '"}')
					orphans.push('Tree:{"ID":"' + Tree.ID + '"}')
					orphans.push('ITrees:{"ID":"' + ITrees.ID + '"}')
					orphans.push('ITrees:{"ID":"' + editITree.ID + '"}')
				}
				Tree.ClientBranches.map(cB => {
					orphans.push('ClientBranch:{"ID":"' + cB.ID + '"}')
				})
				ITrees.ITrees.map(iT => {
					orphans.push('ITree:{"ID":"' + iT.ID + '"}')
					// iT.ClientInstances.map(cI => orphans.push('ClientInstances:{"ID":"' + iT.ID + '"}'))
					// if(cB.iBranch.ID.substring.left(0,2) == "R-"){
					// 	orphans.push('iBranch:{:"ID"' + cB.iBranch.ID + '"}')
					// }	
				})
				orphans.map(o => cache.evict({id:o}))
				// garbage clean-up
				cache.gc()
			},
			// INSTANCE
			createITrees(vars){
				const { Tree, iCollections, iCollection, iTreesID, Collection } = vars
				
				// --- SMART SHAPE EXTRACTOR ---
				// 1. If iCollections (plural connection) exists, extract its edges array.
				// 2. If iCollection (singular flat query) exists, use it directly.
				// 3. Fall back to an empty array if neither is populated yet.
				let collectionsList = [];
				if (iCollections) {
					collectionsList = iCollections.edges || [];
				} else if (iCollection) {
					collectionsList = iCollection;
				}

				if (!_.isEmpty(Tree.ClientBranches) && !this.activeChild){
					const ITrees = [] // collect all ITrees
					const ClientBranch = Tree.ClientBranches[0] // begin with the root ClientBranch
					
					// Loop over our normalized collectionsList
					collectionsList.forEach(iC => { // for each Collection ...
						var ClientInstances = []  // collect ClientInstances. gets passed to makeClientInstance below
						this.makeClientInstance(ClientBranch, ClientInstances, iC, Tree, {})  // begin at the root ClientBranch
						
						// Restore selections from persistent storage
						const selectedInstanceIDs = Collection?.selectedInstanceIDs || []
						const instanceID = iC.RootInstance?.ID
						const isSelected = selectedInstanceIDs.includes(instanceID)
						
						const ITree = {  // create an ITree for this Collection, include ClientInstances accumulated above
							__typename:"ITree",
							ClientInstances: ClientInstances,
							iCollectionID:iC.ID,
							ID: uuidv4(),
							isSelected: isSelected,
							isVisible:true,
							displayImages: false
						}
						ITrees.push(ITree)  // push to array
					})
					
					client.writeFragment({ // write the ITrees for this iCollection
						id: 'ITrees:{"ID":"' + iTreesID + '"}',
						fragment: UpdateITreesFragment,
						fragmentName: 'UpdateITreesFragment',
						data: {ITrees: ITrees},
					})
					return ITrees
				}
				
				return [];
			},
			makeClientInstance(ClientBranch, ClientInstances, iCollection, Tree, parentInstance){
				// console.log('makeClientInstance', ClientBranch)
				const Branch = ClientBranch.Branch // the Branch of this ClientBranch - will always contain an object
				var iBranch = {}
				if (ClientBranch.path == '001'){ // is Root
					iBranch = {
						__typename: "iBranch",
						ID:'R-' + uuidv4(), // R- prefix identifies this as a Root ID which should never create this ID on the server
						Child: _.isEmpty(iCollection.iBranches) ? {}:iCollection.RootInstance,
						Branch: Tree[0] ? Tree[0].Branch : {},  
						Parent: {},  // there is never a parent for a root iBranch
					}
				}else{  // is not Root
					// Match iBranch by exact Child.ID + Parent.ID combo; no false matches
				const parentInstanceID = parentInstance?.ID || ''
				iBranch = iCollection?.iBranches?.find(iB => iB.Branch.Child.ID === Branch.Child.ID && iB.Parent?.ID === parentInstanceID) || {}
				}
				const childClientBranches = Tree.ClientBranches.filter(cB => cB.parentCB?.ID === ClientBranch.ID)
				var digest = []
				// create the digest object for this ClientInstance if it has children and its Branch object has a non empty digests array
				if(childClientBranches.length > 0 && iCollection && !_.isEmpty(ClientBranch.digests)){
					// this ClientBranch has children and digests
					// so get an array of the Branch IDs that have digests
					const digestBranchIDs = childClientBranches.filter(c => c.Branch.digest).map(cB =>cB.Branch.ID)
					// if there is an iBranch
					if(!_.isEmpty(iBranch)){
						// get the child Instances
						const matches = iCollection.iBranches.filter(iB => digestBranchIDs.includes(iB.Branch.ID) && iB.Parent.ID == iBranch.Child.ID)
						matches.map(m => digest.push({digest:m.Branch.digest,Instance:m.Child}))
					}
				}
				var ClientInstance = { // make the ClientInstance object
					__typename:"ClientInstance",
					ClientBranch:ClientBranch,
					clientInstanceRequest:{
						buttons:[],
						mode:'',
						Instance:{},
						req:''
					},
					digest:digest,
					editBuffer:'00100',
					iBranch:iBranch,
					ID: uuidv4(),
					isActive:false,
					parentInstance: parentInstance?parentInstance:{}
				}
				// console.log(ClientInstance)
				ClientInstances.push(ClientInstance) // push it to ClientInstances
				if(!_.isEmpty(childClientBranches)){ // if there are children
					childClientBranches.map(cB => {  // makeClientInstance for each
						cB.ID
						this.makeClientInstance(cB, ClientInstances, iCollection, Tree, iBranch.Child?iBranch.Child:{})
					})
				}
			},
			clientInstanceDisplay(vars){
				// console.log('clientInstanceDisplay', vars)
				// show InstanceView object
				const {ClientInstance, operation} = vars
				if(operation == 'updateValue'){
					this.editBuffer({ClientInstance:ClientInstance,state:"10001"})
				}
				if(operation == 'removeClientInstance' && _.isEmpty(ClientInstance.clientInstanceRequest.Instance)){
					this.editBuffer({ClientInstance:ClientInstance,state:"11001"})
				}
				if(operation == 'cancel'){
					this.editBuffer({ClientInstance:ClientInstance,state:"00100"})
				}
			},
			clientInstanceIsActive(vars){
				// console.log('clientInstanceIsActive -', vars)
				const {ClientInstance,state} = vars
				// this.activeChild = state
				let ID = 'ClientInstance:{"ID":"' + ClientInstance.ID + '"}'
				client.writeFragment({
					id: ID,
					fragment: isActive,
					fragmentName: 'isActive',
					data: {isActive:state},
				})
			},
			editBBuffer(vars){
				// console.log('editBBuffer -', vars)
				// for editing a Tree item
				const { ClientBranch, name } = vars
				// if(name){this.Collection.activeChild = true}
				// set editBBuffer: nodCopy which is a copy of the Nod for this Branch
				client.writeFragment({
					id: client.cache.identify(ClientBranch),
					fragment: editBBuffer,
					fragmentName: 'editBBuffer',
					data: {editBBuffer: name},
				})
			},
			handleResize() {
				this.windowWidth = window.innerWidth
			},
			makePath(filters,iBranches,iBranch,parentPath){
				// console.log('makePath -', iBranches)
				// create an array of filter objects (path:'001.003',filter:Instance)
				// special case for root, create root filter with query name
				if(parentPath == '001'){
					const f = {
							path:parentPath,
							filter:iBranch.Child,
							branchID: null
					}
					filters.push(f)
				}
				// console.log(iBranches)
				const children = iBranches.filter(iB=> iB.Parent.ID == iBranch.Child.ID)
				children.map(c=> {
					const path = parentPath + '.' + ("00" + c.Branch.item).slice(-3)
					if (c.Child.value){
						const f = {
							path:path,
							filter:c.Child,
							branchID: c.Branch.ID
						}
						filters.push(f)
					}
					this.makePath(filters, iBranches, c, path)
				})
			},
			pageCounter(vars){
				// console.log('pageCounter - ', vars)
				const {Collection,offset} = vars
				// console.log(vars)
				// update Collection.pageVars.offset
				client.writeFragment({
					id: client.cache.identify(Collection),
					fragment: UpdatePagesFragment,
					fragmentName: 'UpdatePagesFragment',
					data: {pageVars: {offset:offset}},
				})
			},
			purgeBranchesQuery(root){
				// console.log('purgeBranchesQuery -', vars)
				const allRoots = this.Cluster.Collections.map(c => c.Root.name)
				const orphanRoot = allRoots.includes(root.name)
				if(!orphanRoot){
					// console.log('remove ' + root.name)
					cache.evict({
						id: "ROOT_QUERY",
						fieldName: "Branches",
						args:{root:root.name}
					})
					cache.gc()
				}
			},
			refreshITrees(){
				console.log('refreshITrees()')
				// this will cause all iCollections to refresh
				this.Cluster.Collections.map(c => {
					this.setITreeIsStale({
						iTreeID:c.ITrees.ID,
						state:true
					})
					this.setITreeIsStale({
						iTreeID:c.editITree.ID,
						state:true
					})
				})
			},
			searchCollections(){
				// console.log('searchCollections()')
				// this.clusterEditMode(2)
				// this.clearClientInstances(this.Cluster.Collections[0].ID)
				this.Cluster.Collections.map(c=> this.collectionEnableEdit(c.ID,false))
			},
			setActiveRequest(state){
				// console.log('setActiveRequest -', state)
				// this property is passed down to Collection as a prop
				// it is used to prevent creation of iTree when the clientInstance Request/Reponse loop is active
				this.activeRequest = state
			},
			setCollectionEditMode(Collection,mode){
				// console.log('setCollectionEditMode -', Collection, mode)
				var ID = ('Collection:{"ID":"' + Collection.ID + '"}')
				client.writeFragment({
					id: ID,
					fragment: editMode,
					fragmentName: 'editMode',
					data: {editMode: mode},
				})
			},
			setPauseICollections(mode){
				// console.log('setPauseICollections -', mode)
				const state = mode==0?true:false
				this.pauseICollections = state
			},			
			setRootInstanceID(vars){
				// console.log('setRootInstanceID -', vars)
				const {CollectionID, rootID} = vars
				const ID = 'Collection:{"ID":"' + CollectionID + '"}'
				client.writeFragment({
					id: ID,
					fragment: rootInstanceID,
					fragmentName: 'rootInstanceID',
					data: {rootInstanceID: rootID}
				})
			},
			setTreeIsStale(vars){
				// console.log('setTreeIsStale -', vars)
				const {treeID,state} = vars
				var tID = ('Tree:{"ID":"' + treeID + '"}')
				client.writeFragment({
					id: tID,
					fragment: treeIsStale,
					fragmentName: 'treeIsStale',
					data: {treeIsStale: state},
				})
			},
			setITreeIsStale(vars){
				// console.log('setTreeIsStale -', vars)
				const {iTreeID,state} = vars
				var tID = ('ITrees:{"ID":"' + iTreeID + '"}')
				client.writeFragment({
					id: tID,
					fragment: iTreeIsStale,
					fragmentName: 'iTreeIsStale',
					data: {iTreeIsStale: state},
				})
			},
			triggerRefresh() {
				this.refreshTrigger++; // Increment in methods
			},
			// Group Methods
			startGroupCreation() {
				this.showGroupCreation = true;
				this.newGroupName = 'My ';
			},
			cancelGroupCreation() {
				this.showGroupCreation = false;
			},
			async createGroup() {
				if (!this.newGroupName.trim()) {
					alert('Please enter a group name');
					return;
				}

				// Get selected instance IDs from all collections
				const selectedInstanceIDs = [];
				this.Cluster.Collections.forEach(collection => {
					if (collection.selectedInstanceIDs && collection.selectedInstanceIDs.length > 0) {
						selectedInstanceIDs.push(...collection.selectedInstanceIDs);
					}
				});

				if (selectedInstanceIDs.length === 0) {
					alert('Please select at least one instance to add to the group');
					return;
				}

				try {
					const result = await this.$apollo.mutate({
						mutation: CreateGroupMutation,
						variables: {
							userID: this.authStatus.userID,
							name: this.newGroupName,
							rootInstanceIDs: selectedInstanceIDs
						}
					});

					// Refresh the groups query
					await this.$apollo.queries.userGroups.refetch();

					// Select the new group
					this.selectedGroupID = result.data.CreateGroup.ID;

					this.cancelGroupCreation();
				} catch (error) {
					console.error('Error creating group:', error);
					alert('Failed to create group: ' + error.message);
				}
			},
			async loadGroupCollections() {
				// This method would filter collections based on the selected group
				// For now, we'll just log the selected group
				console.log('Loading collections for group:', this.selectedGroupID);
				// In a real implementation, you would filter this.Cluster.Collections
				// based on the group ID
			},
			async loadAllCollections() {
				console.log('Loading all collections');
				// Reset any group filtering
			},
			updateInstances(mode,BranchID,Collection){
				// console.log('updateInstances -', vars)
				const iTrees = Collection.ITrees.ITrees
				switch(mode){
					// Branch tools
					case 'delete':{
						iTrees.map(iT => {
							const newCIs = iT.ClientInstances.filter(cI => cI.ClientBranch.Branch.ID !== BranchID)
							const iTreeID = 'ITrees:{"ID":"' + iT.ID + '"}'
							client.writeFragment({
								id: iTreeID,
								fragment: UpdateInstanceFragment,
								fragmentName: 'UpdateInstanceFragment',
								data: {ClientInstances: newCIs},
							})
						})
					}
					break
					case 'create':{
						iTrees.map(iT => {
							const newClientInstance = this.createClientInstance
							const iTreeID = 'ITrees:{"ID":"' + iT.ID + '"}'
							client.writeFragment({
								id: iTreeID,
								fragment: UpdateInstanceFragment,
								fragmentName: 'UpdateInstanceFragment',
								data: {ClientInstances: newClientInstance},
							})
						})
					}
					break
				}
			},
		},
		created (){
			// create a Cluster if necessary
			this.Cluster.ID ?? this.createCluster()
		},
		mounted() {
			window.addEventListener('resize', this.handleResize)
		},
		beforeUnmount() {
			window.removeEventListener('resize', this.handleResize)
		},
		computed:{
			allQueries(){
				const allQueries = this.Queries
				const allQ =_.groupBy(allQueries,q => q.iBranches[0].Branch.Parent.ID)
				return allQ
			},
			pinnedQueries(){
				const allQueries = _.orderBy(this.Queries,q =>q.RootInstance.value, 'asc')
				const pinnedQ =allQueries.filter(q => q.RootInstance.isPinned == true)
				const allQ =_.groupBy(pinnedQ, q => q.iBranches[0].Branch.Parent.ID)
				return _.isEmpty(allQ)?[]:allQ
			},
			activeCollections: function (){
				return this.Cluster?.Collections?.filter(c => (c.modalVars?.parentCollectionID || '') == '');
			},
			modalCollections: function() {
				return this.Cluster?.Collections?.filter(c => (c.modalVars?.parentCollectionID || '') !== '');
			},
			scrollWidth: function(){
				return document.getElementById('collections').scrollWidth - document.getElementById('collections').clientWidth
			},
		},
		
	}
</script>

<style scoped>

	*{
		font-family: Arial, sans-serif; /* Set the base font family */
		font-size: 11px; /* Set the base font size */
	}
	.cluster{
		/* height: calc(100vh - 100px); */
		height: 100%;
		overflow: hidden;
		display: flex;
		flex-direction: column;
		min-height: 0;
	}
		.cluster-controls{
				display: flex;
				height: 24px;
				margin:5px;
				white-space: nowrap;
				flex: 0 0 auto;
			}
			.spacer{
				width: 1px;
			}
			.query-button {
				align-items: center;
				border: 1px solid black;
				border-radius: 4px;
				display: inline-flex;
				justify-content: center;
				height: inherit;
				margin-right: 0.5px;
				min-width: 17px;
				padding:0;
			}
			.button-image{
				height: 15px;
			}			
			.hover:hover{
				background-color: #a6f4e5;
			}
			.selected{
				background-color: #42f545;
				font-weight: bold;
			}

		.images{
			/* height: 24px; */
			margin-left: 5px;
			margin-top: 5px;
			flex: 0 0 auto;
		}

		.collections-container{
			height: 100%;
			/* height: calc(100vh - 115px); */
			margin: 5px;
			flex: 1 1 auto;
			min-height: 0;
			overflow-y: auto;
			overflow-x:hidden;
		}

</style>